import { QuantitySelectorComponent } from '@theme/component-quantity-selector';
import { parseIntOrDefault } from '@theme/utilities';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();
    const purchaseLimit = parseIntOrDefault(this.refs.quantityInput.getAttribute('data-purchase-limit'), null);
    const atMax = effectiveMax !== null && value >= effectiveMax;

    // Cart buttons are always dynamically managed
    minusButton.disabled = value <= min;

    // Keep plus clickable at purchase limit so we can show a toast on click
    if (atMax && purchaseLimit !== null) {
      plusButton.disabled = false;
      plusButton.setAttribute('aria-disabled', 'true');
      plusButton.classList.add('quantity-plus--at-limit');
    } else {
      plusButton.disabled = atMax;
      plusButton.removeAttribute('aria-disabled');
      plusButton.classList.remove('quantity-plus--at-limit');
    }
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
